<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <form-component
      :formData="formData"
    >
    </form-component>
  </v-container>
</template>

<script>
// https://github.com/ejcubillas/phil-reg-prov-mun-brgy?tab=readme-ov-file
import phil from 'phil-reg-prov-mun-brgy';

import Loader from '../../../components/utilities/Loader.vue';
import FormComponent from '../../../components/ui/FormComponent.vue';

export default {
  name: 'CollectingInstitutionForm',
  components: {
    FormComponent,
    Loader,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    collectingInstitution: Object,
  },
  data() {
    return {
      philRegions: [],
      philProvinces: [],
      formData: {
        onSubmit: this.onSubmit,
        model: this.collectingInstitution,
        widgets: [
          {
            type: 'text',
            name: 'name',
            label: 'Name',
            value: '',
            counter: 100,
            maxLength: 100,
            rules: [
              (v) => !!v || 'Name is required',
            ],
          },
          {
            type: 'select',
            name: 'region',
            label: 'Site of Collection (Region)',
            placeholder: 'Select a Region',
            multiple: false,
            readonly: false,
            items: [],
            value: '',
          },
          {
            type: 'select',
            name: 'province',
            label: 'Site of Collection (Province)',
            placeholder: 'Select a Province',
            multiple: false,
            readonly: false,
            items: [],
            value: '',
          },
          {
            type: 'textarea',
            name: 'description',
            label: 'Description',
            value: '',
            counter: 255,
            maxLength: 255,
          },
          {
            type: 'button',
            btnType: 'submit',
            name: 'save',
            label: 'Save',
            color: 'primary',
            value: null,
          },
        ],
      },
    };
  },
  async created() {
    this.philRegions = phil.regions;
    this.philProvinces = phil.provinces;

    const regionsWidget = this.formData
      .widgets
      .find((w) => w.name === 'region');

    regionsWidget.items = this.philRegions
      .map((d) => ({ code: d.reg_code, label: d.name }));

    const provincesWidget = this.formData
      .widgets
      .find((w) => w.name === 'province');

    provincesWidget.items = this.philProvinces
      .map((d) => ({ code: d.prov_code, label: d.name }));
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    async 'formData.widgets.1.value'(id) {
      const regionProvinces = this.philProvinces.filter((province) => province.reg_code === id);
      const provincesWidget = this.formData
        .widgets
        .find((w) => w.name === 'province');
      provincesWidget.items = regionProvinces
        .map((d) => ({ code: d.prov_code, label: d.name }));
    },
  },
};
</script>
